import { Footer } from "@/components/layout/Footer";
import { Hero } from "@/components/home/Hero";
import { Introduction } from "@/components/home/Introduction";
import { WhyUs } from "@/components/home/WhyUs";
import { FeaturedJourneys } from "@/components/home/FeaturedJourneys";
import { SpiritualPaths } from "@/components/home/SpiritualPaths";
import { Testimonials } from "@/components/home/Testimonials";
import { CallToAction } from "@/components/home/CallToAction";
import { SEO } from "@/components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Spiritual Journeys & Pilgrimages in India" 
        description="Experience transformative spiritual journeys and pilgrimages in India. Discover sacred paths, ancient rituals, and authentic cultural encounters."
        canonical="https://baelleaves.com/"
      />
      <main>
        <Hero />
        <Introduction />
        <WhyUs />
        <FeaturedJourneys />
        <SpiritualPaths />
        <Testimonials />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
